<template>
    <div>
        <div class="simple-row">
            <div class="left">
                <a class="swb-btn swb-btn-small" @click="toPrint">打印</a>
            </div>
        </div>
        <div class="content-caption dashed">
            <span>调拨信息</span>
            <div class="shrink-tab fr" :class="showTransVoucherInfoFlag ? 'current': ''" @click="doShowTransVoucherInfo()">
                <span>{{ showTransVoucherInfoFlag ? '隐藏' : '展开' }}</span>
                <i :class="showTransVoucherInfoFlag ? 'el-icon-arrow-down': 'el-icon-arrow-right'"></i>
            </div>
        </div>
        <template v-if="showTransVoucherInfoFlag">
            <div class="simple-form flex col-4">
                <div class="form-group center">
                    <div class="form-label">
                        <label>调拨单号</label>
                    </div>
                    <div class="form-value">
                        <el-tag v-if="transVoucherInfo.srcVoucherType != null" type="danger">{{ voucherTypeMap[transVoucherInfo.srcVoucherType] }}</el-tag>
                        <span>{{ transVoucherInfo.innerNo || '无' }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>记账凭证号</label>
                    </div>
                    <div class="form-value">
                        <span>{{ transVoucherInfo.reservedNo || '无' }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>调拨总数量</label>
                    </div>
                    <div class="form-value">
                        <span>{{ transVoucherInfo.totalQuantity }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>调拨总金额</label>
                    </div>
                    <div class="form-value">
                        <span>{{ parseFloat(transVoucherInfo.totalNetWorth || 0).toFixed(2) }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>创建机构</label>
                    </div>
                    <div class="form-value">
                        <span>{{ transVoucherInfo.creatorComName || '无' }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>申请人</label>
                    </div>
                    <div class="form-value">
                        <span>{{ transVoucherInfo.applicantName || '无' }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>申请人电话</label>
                    </div>
                    <div class="form-value">
                        <span>{{ transVoucherInfo.applicantContactTel || '无' }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label></label>
                    </div>
                    <div class="form-value">
                        <span></span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>调出机构</label>
                    </div>
                    <div class="form-value">
                        <span>{{ transVoucherInfo.srcComFullName || '无' }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>调出机构编码</label>
                    </div>
                    <div class="form-value">
                        <span>{{ transVoucherInfo.srcBizUnitCode || '无' }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>调出成本中心</label>
                    </div>
                    <div class="form-value">
                        <span>{{ transVoucherInfo.srcCostCenterCode || '无' }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>调出利润中心</label>
                    </div>
                    <div class="form-value">
                        <span>{{ transVoucherInfo.srcPrftCenterCode || '无' }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>调入机构</label>
                    </div>
                    <div class="form-value">
                        <span>{{ transVoucherInfo.dstComFullName || '无' }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>调入机构编码</label>
                    </div>
                    <div class="form-value">
                        <span>{{ transVoucherInfo.dstBizUnitCode || '无' }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>调入成本中心</label>
                    </div>
                    <div class="form-value">
                        <span>{{ transVoucherInfo.dstCostCenterCode || '无' }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>调入利润中心</label>
                    </div>
                    <div class="form-value">
                        <span>{{ transVoucherInfo.dstPrftCenterCode || '无' }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>调拨日期</label>
                    </div>
                    <div class="form-value">
                        <span>{{ transVoucherInfo.createTime || '无' }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>申请日期</label>
                    </div>
                    <div class="form-value">
                        <span>{{ transVoucherInfo.applyTime || '无' }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>生凭时间</label>
                    </div>
                    <div class="form-value">
                        <span>{{ transVoucherInfo.ledgerTime || '无' }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label></label>
                    </div>
                    <div class="form-value">
                        <span></span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label v-if="reserveFlag">预定说明</label>
                        <label v-else>申请原因</label>
                    </div>
                    <div class="form-value">
                        <span>{{ transVoucherInfo.applyDesc || '无' }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>标题</label>
                    </div>
                    <div class="form-value">
                        <span>{{ transVoucherInfo.memo || '无' }}</span>
                    </div>
                </div>
            </div>
        </template>
        <div class="content-caption dashed">
            <span>{{ transVoucherInfo.assetType != 2 ? '资产信息' : '耗材信息' }}</span>
            <div class="shrink-tab fr" :class="showDeviceItemFlag? 'current': ''" @click="doShowDeviceItem()">
                <span>{{ showDeviceItemFlag ? '隐藏' : '展开' }}</span>
                <i :class="showDeviceItemFlag? 'el-icon-arrow-down': 'el-icon-arrow-right'"></i>
            </div>
        </div>
        <template v-if="showDeviceItemFlag">
            <div v-if="!transVoucherInfo.suitFlag">
                <div class="table-layout" v-if="deviceItemList != null && deviceItemList.length > 0">
                    <el-table ref="multipleTable" :data="deviceItemList" border tooltip-effect="dark" style="width: 100%" maxHeight="500">
                        <el-table-column align="left" prop="innerCode" min-width="200" label="资产编号" fixed show-overflow-tooltip>
                            <template slot-scope="rows">
                                <a class="table-cell-link" @click="viewAssetInfo(rows.row.innerCode, rows.row.assetType)">{{ rows.row.innerCode }}</a>
                            </template>
                        </el-table-column>
                        <el-table-column align="left" prop="title" label="资产描述全称" width="200" fixed show-overflow-tooltip></el-table-column>
                        <el-table-column align="center" prop="initInnerCode" label="原始资产编号" width="200" show-overflow-tooltip v-if="transVoucherInfo.receiptState == 1 || transVoucherInfo.receiptState == 2"></el-table-column>
                        <el-table-column align="right" prop="quantity" width="100" label="调拨数量"></el-table-column>
                        <el-table-column label="控制方式" align="center" width="80">
                            <template slot-scope="scope">
                                <span>{{ scope.row.splitible ? '按金额' : '按数量' }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" prop="splittedAmount" width="100" label="调拨原值(元)">
                            <template slot-scope="rows">
                                <span v-if="rows.row.splittedAmount != null">{{ rows.row.splittedAmount.toFixed(2) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" prop="orgWorth" width="80" label="资产原值(元)">
                            <template slot-scope="rows">
                                <span v-if="rows.row.assetOrgWorth != null">{{ rows.row.assetOrgWorth.toFixed(2) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" prop="orgWorth" width="80" label="调入原值(元)">
                            <template slot-scope="rows">
                                <span v-if="rows.row.orgWorth2 != null">{{ rows.row.orgWorth2.toFixed(2) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" prop="netWorth" width="80" label="调入净值(元)">
                            <template slot-scope="rows">
                                <span v-if="rows.row.netWorth2 != null">{{ rows.row.netWorth2.toFixed(2) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="dstComFullName" label="调入机构" width="300" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <span v-if="scope.row.dstMerchantId != scope.row.retailerId && scope.row.dstMerchantName != null">{{ scope.row.dstMerchantName }}</span>
                                <span v-if="scope.row.dstMerchantId != scope.row.retailerId && scope.row.dstMerchantName != null && scope.row.dstComFullName != null">/</span>
                                <span v-if="scope.row.dstComFullName != null">{{ scope.row.dstComFullName }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="fiscalInTime" label="入账时间" align="right">
                            <template slot-scope="rows">
                                <span v-if="rows.row.fiscalInTime != null">{{ rows.row.fiscalInTime }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="innerNo" label="外部资产编码" width="180" align="left"></el-table-column>
                        <el-table-column prop="dstComNo" label="调入机构编号" width="120"></el-table-column>
                        <el-table-column prop="dstCostCenterCode" label="调入成本中心" width="160"></el-table-column>
                        <el-table-column prop="srcComFullName" label="调出机构" width="140" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="srcRealComCode" label="调出公司编码" width="160"></el-table-column>
                        <el-table-column prop="srcCostCenterCode" label="调出成本中心" width="160"></el-table-column>
                        <el-table-column align="left" prop="fixedSpec" label="规格" width="150" show-overflow-tooltip></el-table-column>
                        <el-table-column align="center" prop="theUnit" min-width="50" label="单位"></el-table-column>
                        <el-table-column align="left" prop="assetNature" label="资产属性" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span>{{ assetNatureMap[rows.row.assetNature] }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" prop="fiscalAcctFlag" width="100" label="是否在账">
                            <template slot-scope="rows">
                                <span>{{ rows.row.fiscalAcctFlag ? '是' : '否' }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" prop="reserved" width="100" label="预定情况" v-if="reserveFlag">
                            <template slot-scope="rows">
                                <span>{{ rows.row.reserved ? '已被预定' : '可以预定' }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" prop="quantity2" width="100" label="含报废数量">
                            <template slot-scope="rows">
                                <span>{{ rows.row.quantity2 || 0 }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="left" prop="dstInnerCode" min-width="200" label="调入资产编号">
                            <template slot-scope="rows">
                                <a class="table-cell-link" v-for="dstInnerCode in rows.row.dstInnerCodeList" @click="viewAssetInfo(dstInnerCode, rows.row.assetType)">{{ dstInnerCode }}</a>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" prop="aggtDeprWorth" width="100" label="调入累计折旧(元)">
                            <template slot-scope="rows">
                                <span v-if="rows.row.aggtDeprWorth2 != null">{{ rows.row.aggtDeprWorth2.toFixed(2) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" prop="taxRate" width="80" label="税率(%)">
                            <template slot-scope="rows">
                                <span v-if="rows.row.taxRate != null">{{ rows.row.taxRate.toFixed(2) }}</span>
                                <span v-else>0</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="left" prop="memo" min-width="100" label="备注" show-overflow-tooltip></el-table-column>
                        <el-table-column align="left" prop="tmpNo" width="250" label="系统编号"></el-table-column>
                        <el-table-column prop="assetType" width="100" label="管理方式" align="center">
                            <template slot-scope="rows">
                                <span>{{ assetTypeMap[rows.row.assetType] }}</span>
                            </template>
                        </el-table-column>
                        <template v-for="colNameX in colNames">
                            <el-table-column :label="colNameX" align="center" width="200" show-overflow-tooltip>
                                <template slot-scope="scope">
                                    <template v-if="scope.row.reservedNoJson != null" v-for="theJson in scope.row.reservedNoJson">
                                        <span v-if="theJson.text == colNameX">{{ theJson.value }}</span>
                                    </template>
                                </template>
                            </el-table-column>
                        </template>

                        <el-table-column prop="devcCustTag1Val" :label="devcCustTag1.dispName" width="120" v-if="devcCustTag1.enabled == true" >
                        </el-table-column>
                        <el-table-column prop="devcCustTag2Val" :label="devcCustTag2.dispName" width="120" v-if="devcCustTag2.enabled == true">
                        </el-table-column>
                        <el-table-column prop="devcCustTag3Val" :label="devcCustTag3.dispName" width="120" v-if="devcCustTag3.enabled == true">
                        </el-table-column>

                        <el-table-column align="left" width="120" label="操作">
                            <template slot-scope="rows">
                                <span class="swb-btn swb-btn-link" @click="changeInfo(rows.row.innerCode)">调拨变动详情</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="pagination-layout">
                    <el-pagination background :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange"
                                   layout="total, sizes, prev, pager, next, jumper"></el-pagination>
                </div>
            </div>
            <div class="table-layout" v-else>
                <el-table :data="deviceItemList" border>
                    <el-table-column align="left" prop="innerCode" min-width="250" fixed label="资产编号" show-overflow-tooltip>
                        <template slot-scope="rows">
                            <a class="table-cell-link" @click="viewAssetInfo(rows.row.innerCode, rows.row.assetType)">{{ rows.row.innerCode }}</a>
                        </template>
                    </el-table-column>
                    <el-table-column prop="title" label="设备名称" align="left" width="150" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="tmpNo" label="系统编号" align="center"></el-table-column>
                    <el-table-column label="是否主资产" align="center" width="100">
                        <template slot-scope="rows">
                            <span v-if="rows.row.suitMainFlag" class="font-green">是</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="suitNo" label="套装编号" align="center" width="200"></el-table-column>
                    <el-table-column prop="catName" label="设备分类" width="150" align="left" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="groupName" label="维保分组" width="120" align="left" show-overflow-tooltip>
                        <template slot-scope="rows">
                            <span>{{ getGoodsCatDevcGroupName(rows.row.catId) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="brandName" label="设备品牌" width="150" align="left" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="modelSpec" label="设备规格" width="150" align="left" show-overflow-tooltip></el-table-column>
                    <el-table-column align="left" prop="srcComName" width="100" label="调出部门"></el-table-column>
                    <el-table-column align="left" prop="srcWarehouseName" width="100" label="调出仓库"></el-table-column>
                    <el-table-column align="left" prop="dstComName" width="100" label="调入部门"></el-table-column>
                    <el-table-column align="left" prop="dstWarehouseName" width="100" label="调入仓库"></el-table-column>
                </el-table>
            </div>
        </template>
        <div v-if="!reserveFlag && shopDeviceTransFileList != null && shopDeviceTransFileList.length > 0">
            <div class="content-caption dashed">
                <span>附件信息</span>
                <div class="shrink-tab fr" :class="showShopDeviceTransFlag? 'current': ''" @click="doShowShopDeviceTrans()">
                    <span>{{ showShopDeviceTransFlag ? '隐藏' : '展开' }}</span>
                    <i :class="showShopDeviceTransFlag ? 'el-icon-arrow-down': 'el-icon-arrow-right'"></i>
                </div>
            </div>
            <template v-if="showShopDeviceTransFlag">
                <div class="file-view-list">
                    <div class="file-view-header">
                        <div class="file-name">名称</div>
                        <div class="file-opera">操作</div>
                    </div>
                    <template v-for="(fileInfo, index) in shopDeviceTransFileList">
                        <swb-file-item-li :trackKey="index" :fileName="fileInfo.name" :fileBrowseUrl="fileInfo.fileBrowseUrl" :fileDownloadUrl="fileInfo.fileBrowseUrl" :fileUuid="fileInfo.fileUuid" :deletable="false"></swb-file-item-li>
                    </template>
                </div>
            </template>
        </div>
        <template v-if="!reserveFlag && transVoucherInfo.outerAuditFlag && transVoucherInfo.applyState != 0 && checkActionPerm('audit_rec') && recList.length > 0">
            <div class="content-caption dashed">
                <span>审核记录</span>
                <div class="shrink-tab fr" :class="showOaAuditFlag ? 'current': ''" @click="doShowOaAuditInfo()">
                    <span>{{ showOaAuditFlag ? '隐藏' : '展开' }}</span>
                    <i :class="showOaAuditFlag ? 'el-icon-arrow-down': 'el-icon-arrow-right'"></i>
                </div>
            </div>
            <template v-if="showOaAuditFlag">
                <swb-oa-audit-rec-list :bizTypeCode="'retailer.assets.allot'" :bizVoucherNo="transVoucherInfo.innerNo" :auditSeqNo="transVoucherInfo.auditSeqNo" ref="swb_oa_audit_rec_list"></swb-oa-audit-rec-list>
            </template>
        </template>
        <template v-if="!reserveFlag && !transVoucherInfo.outerAuditFlag && checkActionPerm('view_rec') && transVoucherInfo.no != null">
            <div class="content-caption dashed bg-white">
                <span>审核记录</span>
                <div class="shrink-tab fr" :class="showDeviceActFlag ? 'current': ''" @click="doShowDeviceActInfo()">
                    <span>{{ showDeviceActFlag ? '隐藏' : '展开' }}</span>
                    <i :class="showDeviceActFlag ? 'el-icon-arrow-down': 'el-icon-arrow-right'"></i>
                </div>
            </div>
            <template v-if="showDeviceActFlag">
                <swb-shop-device-act-rec-list :showQuery="false" :showComFlag="true" :srcVoucherNo="transVoucherInfo.no" :srcVoucherType="3" ref="swb_shop_device_act_rec_list"></swb-shop-device-act-rec-list>
            </template>
        </template>
    </div>
</template>

<script>
    import {Utils} from '../../app.base'
    import {Vue, MsgBox, Routes} from '../../app.vues'
    import {getDefaultPageSizes} from '../../app.conf'
    import {getDevcGroupNameByCatId} from '../index'
    import {assetFiscalInfoDlg} from '../retailer/dialog'
    import {checkUserActionPerm} from '../index'

    import assetVchrApi from '../../api/assetVchr'
    import oaAuditApi from '../../api/oaAudit'
    //
    import SwbAssetTransDtlListMain from '../bizDtl/AssetTransDtlListMain';

    Routes.add(SwbAssetTransDtlListMain);

    import AuditBpRecsList from '../oaAudit/AuditBpRecsList.vue';

    Vue.regist(AuditBpRecsList);
    import SwbShopDeviceTransVoucherApplyList from './ShopDeviceTransVoucherApplyList'

    Vue.regist(SwbShopDeviceTransVoucherApplyList);

    import SwbFileItemLi from '../ctrl/FileItemLi';
    import custTagMeataApi from '../../api/objTagConf';

    Vue.regist(SwbFileItemLi);

    export default {
        name: 'swb-trans-voucher-view',
        avlActions: '',
        avlScopes: 'vendor',
        notAsResc: true,
        authen: false,
        desc: '商品调拨单-详情',
        props: {
            id: {
                type: Number,
                default: null,
            },
            no: {
                type: String,
                default: null,
            },
            directFlag: {
                type: Boolean,
                default: false
            },
            reserveFlag: { // 预定调拨单
                type: Boolean,
                default: false
            },
            parentSelf: {
                type: Object,
                default: {}
            }
        },
        data: function () {
            return {
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                pageNumber: 1,
                //
                transVoucherInfo: {},
                deviceItemList: [],
                voucherTypeMap: [],
                crossComFlag: false,
                disabledOut: true,
                ledgerStateMap: getEnumMap('ledgerState', 'value2text'),
                assetNatureMap: getEnumMap('assetNature', 'value2text'),
                assetTypeMap: getEnumMap("assetType", "value2text"),
                //
                acctEnterWayMap: {},
                shopDeviceTransFileList: [],
                recList: [],
                showDeviceItemFlag: true,
                showTransVoucherInfoFlag: true,
                showOaAuditFlag: true,
                showDeviceActFlag: true,
                showShopDeviceTransFlag: true,
                colNames: [],
                devcCustTag1: {
                    dispName: '自定义标签1',
                    itemList: [],
                    enabled: false,
                    refUsed: false
                },
                devcCustTag2: {
                    dispName: '自定义标签2',
                    itemList: [],
                    enabled: false,
                    refUsed: false
                },
                devcCustTag3: {
                    dispName: '自定义标签3',
                    itemList: [],
                    enabled: false,
                    refUsed: false
                }
            }
        },
        created: function () {
            this.getCustTagMetaFields();
            this.pageSize = this.pageSizes.first();
            this.acctEnterWayMap = getEnumMap("acctEnterWay", "value2text");
            this.voucherTypeMap = getEnumMap("devcVoucherType", "value2text");
            this.getShopDeviceTransVoucher();
        },
        methods: {
            getMerchtAuditBpRecsByBizVoucherNo: function () {
                let self = this;
                let params = {
                    bizVoucherNo: this.transVoucherInfo.innerNo,
                    bizTypeCode: 'retailer.assets.allot',
                    auditSeqNo: this.transVoucherInfo.auditSeqNo
                };
                //
                let theLoad = MsgBox.loading();
                oaAuditApi.getMerchtAuditBpRecsByBizVoucherNo(params, function (result) {
                    theLoad.hide();
                    if (result.type === "info") {
                        self.recList = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            checkActionPerm: function (action, targetPostId, dataOwnerComId) {
                return checkUserActionPerm(SwbShopDeviceTransVoucherApplyList.path, action, targetPostId, dataOwnerComId);
            },
            getShopDeviceTransFileListByVoucherId: function (voucherId) {
                let self = this;
                let postData = {};
                postData.voucherId = voucherId;
                assetVchrApi.getShopDeviceTransFileListByVoucherId(postData, function (result) {
                    if (result.type == "info") {
                        self.shopDeviceTransFileList = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            getGoodsCatDevcGroupName: function (catId) {
                return getDevcGroupNameByCatId(catId);
            },
            getShopDeviceTransVoucher: function () {
                let self = this;
                let postData = {};
                postData.id = self.id;
                postData.no = self.no;
                let theLoading = MsgBox.loading();
                assetVchrApi.getShopDeviceTransVoucher(postData, function (result) {
                    theLoading.close();
                    if (result.type == "info") {
                        let transVoucherInfo = result.data;
                        self.transVoucherInfo = transVoucherInfo;
                        self.getShopDeviceTransVoucherItems();
                        self.crossComFlag = self.transVoucherInfo.crossComFlag;
                        self.getShopDeviceTransFileListByVoucherId(transVoucherInfo.id);
                        if (transVoucherInfo.outerAuditFlag && transVoucherInfo.applyState != 0) {
                            self.getMerchtAuditBpRecsByBizVoucherNo();
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getShopDeviceTransVoucherItems();
            },
            getShopDeviceTransVoucherItems() {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                let filterItems = {};
                filterItems.voucherId = self.transVoucherInfo.id;
                postData.filterItems = filterItems;
                let theLoading = MsgBox.loading();
                assetVchrApi.getShopDeviceTransVoucherItemList(postData, function (result) {
                    theLoading.close();
                    if (result.type === "info") {
                        let data = result.data;
                        self.getTransReceiptOrDirectQuantity(function (resultData) {
                            let receiptQuantityMap = resultData.receiptQuantityMap || {};
                            let directQuantityMap = resultData.directQuantityMap || {};
                            let colNames = [];
                            let deviceItemList = data.rows || [];
                            if (deviceItemList.length > 0) {
                                deviceItemList.forEach(function (item) {
                                    //
                                    item.transAvQuantity = item.quantity - item.quantity2;
                                    let receiptQuantity = 0;
                                    if (!Utils.isNoB(receiptQuantityMap) && receiptQuantityMap[item.id] != null) { // 已验收
                                        receiptQuantity = receiptQuantityMap[item.id];
                                    }
                                    let directQuantity = 0;
                                    if (!Utils.isNoB(directQuantityMap) && directQuantityMap[item.id] != null) { // 已退还
                                        directQuantity = directQuantityMap[item.id];
                                    }
                                    item.receiptQuantity = receiptQuantity;
                                    item.directQuantity = directQuantity;
                                    let dstInnerCode = item.dstInnerCode;
                                    let dstInnerCodeList = [];
                                    if (dstInnerCode != null && dstInnerCode != '') {
                                        dstInnerCodeList = dstInnerCode.split('|');
                                    }
                                    item.dstInnerCodeList = dstInnerCodeList;
                                    //
                                    let reservedNo = item.reservedNo;
                                    if (!Utils.isNoB(reservedNo)) {
                                        let reservedNoJson = JSON.decode(reservedNo);
                                        let theNames = reservedNoJson.pluck('text');
                                        item.reservedNoJson = reservedNoJson;
                                        colNames.add(Utils.compareArrays(theNames, colNames)['more']);
                                    }
                                });
                                self.colNames = colNames;
                                self.deviceItemList = Utils.merge([], deviceItemList);
                            }
                        });
                        self.totalCount = data.pagination.totalCount;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getTransReceiptOrDirectQuantity: function (callBack) {
                let self = this;
                let postData = {
                    transVoucherId: self.transVoucherInfo.id
                };
                let theLoad = MsgBox.loading();
                assetVchrApi.getTransReceiptOrDirectQuantity(postData, function (result) {
                    theLoad.hide();
                    if (result.type === "info") {
                        callBack(result.data);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            //
            viewAssetInfo: function (innerCode, assetType) {
                let params = {
                    innerCode: innerCode,
                    assetType: assetType
                };
                assetFiscalInfoDlg(params);
            },
            // 调拨变动详情
            changeInfo: function (innerCode) {
                let self = this;
                let {href} = this.parentSelf.$router.resolve({
                    path: SwbAssetTransDtlListMain.path,
                    query: {
                        transVoucherNo: self.transVoucherInfo.no,
                        innerCode: innerCode
                    },
                });
                window.open(href, '_blank');
            },
            // 隐藏、展开
            doShowDeviceItem: function () {
                this.showDeviceItemFlag = !this.showDeviceItemFlag;
            },
            // 隐藏、展开
            doShowTransVoucherInfo: function () {
                this.showTransVoucherInfoFlag = !this.showTransVoucherInfoFlag;
            },
            // 隐藏、展开
            doShowOaAuditInfo: function () {
                this.showOaAuditFlag = !this.showOaAuditFlag;
            },
            // 隐藏、展开
            doShowDeviceActInfo: function () {
                this.showDeviceActFlag = !this.showDeviceActFlag;
            },
            // 隐藏、展开
            doShowShopDeviceTrans: function () {
                this.showShopDeviceTransFlag = !this.showShopDeviceTransFlag;
            },
            toPrint() {
                let collapsedBlocks = [];
                if (!this.showTransVoucherInfoFlag) {
                    collapsedBlocks.push('transVoucherInfo');
                }
                if (!this.showDeviceItemFlag) {
                    collapsedBlocks.push('deviceItemList');
                }
                if (!this.showShopDeviceTransFlag) {
                    collapsedBlocks.push('shopDeviceTransFileList');
                }
                if (!this.showOaAuditFlag) {
                    collapsedBlocks.push('oaRecList');
                }
                if (!this.showDeviceActFlag) {
                    collapsedBlocks.push('actRecList');
                }

                let transVoucherInfo = this.transVoucherInfo;
                let url = '/voucher/print/jsp';
                let postData = {
                    bizType: 'biz.proof.zichan.diaobo',
                    voucherId: transVoucherInfo.id,
                    collapsedBlocks: collapsedBlocks.join(',')
                };
                let printUrl = Utils.makeUrl(getAppUrl(url), postData);
                Utils.setPageUrl(printUrl, '_blank');
            },
            getCustTagMetaFields: function () {
                let self = this
                let param = [{tagMetaTableName: 'shop_device', tagMetaRole: 1}]
                custTagMeataApi.getCustTagMetaFields(param, function (result) {
                    if (result.type == 'info') {
                        let tags = result.data
                        for(let i=0; i< tags.length; i++) {
                            let tag = tags[i]
                            if(tag.fieldName == 'devcCustTag1') {
                                self.devcCustTag1 = {
                                    dispName: tag.dispName,
                                    itemList: tag.itemList,
                                    enabled: tag.enabled,
                                    refUsed: tag.refUsed
                                }
                            } else if(tag.fieldName == 'devcCustTag2') {
                                self.devcCustTag2 = {
                                    dispName: tag.dispName,
                                    itemList: tag.itemList,
                                    enabled: tag.enabled,
                                    refUsed: tag.refUsed
                                }
                            } else if(tag.fieldName == 'devcCustTag3') {
                                self.devcCustTag3 = {
                                    dispName: tag.dispName,
                                    itemList: tag.itemList,
                                    enabled: tag.enabled,
                                    refUsed: tag.refUsed
                                }
                            }
                        }
                    } else {
                        MsgBox.warning(result.message)
                    }
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/transVoucher/ShopDeviceTransVoucherView.vue